import { CommandResponseMode } from "lib/deviceDrivers/sessionFramework/device/types";
import { FrameType, type ScpFrame } from "./types";

const DEVICE_ERROR_PATTERN = /^\(([A-F0-9]{2})\)$/;
export enum ErrorCode {
  INVALID_CHECKSUM = "FF",
  COMMAND_UNKNOWN = "FD",
  BAD_ADDRESS = "FC",
  BAD_COMMAND = "FB",
  SYNTAX_ERROR = "FA",
  OUT_OF_RANGE = "F9",
  PARAMETER_MISMATCH = "10",
  PARAMETER_STRING_TOO_LONG = "11",
  PARAMETER_EXPECTED = "12",
  TOO_MANY_PARAMETERS = "13",
  DEVICE_BUSY = "14",
}

export function parseScpFrame(serializedPayload: string): ScpFrame {
  const raw = `${serializedPayload ?? ""}`.trim();

  if (raw === "^") {
    return { type: FrameType.ACK, raw };
  }

  const errorMatch = DEVICE_ERROR_PATTERN.exec(raw);
  if (errorMatch) {
    return { type: FrameType.ERROR, code: errorMatch[1], raw };
  }

  if (raw.startsWith("[") && raw.endsWith("]")) {
    const value = raw.slice(1, -1).trim();
    return { type: FrameType.BRACKET, value: value || null, raw };
  }

  return { type: FrameType.TEXT, value: raw, raw };
}

export function matchesResponseMode(
  responseMode: CommandResponseMode,
  frame: ScpFrame,
): boolean {
  switch (responseMode) {
    case CommandResponseMode.NONE:
      return false;
    case CommandResponseMode.ACK:
      return frame.type === FrameType.ACK;
    case CommandResponseMode.DATA:
      return frame.type === FrameType.BRACKET || frame.type === FrameType.TEXT;
    case CommandResponseMode.ACK_OR_DATA:
      return (
        frame.type === FrameType.ACK ||
        frame.type === FrameType.BRACKET ||
        frame.type === FrameType.TEXT
      );
    default:
      return false;
  }
}

export function isRetryableDeviceErrorCode(code: string): boolean {
  return code === ErrorCode.DEVICE_BUSY;
}
